/** @format */

import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { CommonWidgetsModule } from '@dcsg-ngx-ecommerce/engage/component/common-widgets/common-widgets.module';
import { CtaModule } from '../cta/cta.module';
import { EmailSignupModule } from '@dcsg-ngx-ecommerce/engage/component/email-signup/email-signup.module';
import { ExclusiveProductPanelModule } from '@shared/components';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { MediaModule } from '@shared/media/components';
import { NoBackgroundDirective } from '@shared/utils/directives';
import { PricedPackageModule } from '../priced-package/priced-package.module';
import { QuickviewCtaModule } from '../quickview-cta/quickview-cta.module';
import { StoryComponent } from './story.component';
import { StripSpecialCharsPipe } from '@shared/utils/pipes';
import { WysiwygModule } from '../wysiwyg/wysiwyg.module';

@NgModule({
	imports: [
		CommonModule,
		CommonWidgetsModule,
		CtaModule,
		EmailSignupModule,
		ExclusiveProductPanelModule,
		HmfButtonComponent,
		MediaModule,
		NoBackgroundDirective,
		PricedPackageModule,
		QuickviewCtaModule,
		StripSpecialCharsPipe,
		WysiwygModule
	],
	declarations: [StoryComponent],
	exports: [StoryComponent],
	schemas: [NO_ERRORS_SCHEMA],
	bootstrap: [StoryComponent]
})
export class StoryModule {}
